<!-- Nav Menu -->

<template>
  <div id="app" :class="{nooverflow : this.$route.name != 'oom'}">
    <Menu :route="route" :config="env"/>
    <transition name="fade" appear>
      <router-view
        :config="env"
        :key="$route.fullPath"
    /></transition>
      <CookieBanner />
    <div class='foot'>
      <b-row>
        <b-col>
          <span class='footList'>
          <p style="text-transform: initial;margin-top: 2.9em; padding-left: 30px;">
             ©  {{new Date().getFullYear()}} PGM Professional Golf of Malaysia
          </p>
          </span>
        </b-col>
        <b-col>
          <span class='copyRight'>
            <a href="https://ocs-sport.com" target='_blank'>
              <div class="logoCen">
                <img class="LogoOCS" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Sport_white.png">
                <p>Powering Websites,<br> Data, Apps & Systems</p>
              </div>
            </a>
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>
.LogoOCS {
  width: 70px;
}
.logoCen.Mob {
  text-align: left;
  font-size: 9pt;
  position: relative;
  top: -15px;
}
.logoCen {
  text-align: right;
  font-size: 9pt;
  position: relative;
  top: -15px;
  color:#fff
;
}
::v-deep .nooverflow {
  overflow: hidden;
}
/* .overflowPage {
  overflow: hidden;
} */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14pt;
}
li.nav-item::marker {
  color: transparent;
}
.footList{
  text-transform: capitalize;
    font-size: 9pt;
}
.foot{
  color: #fdfff7;
    background-color: #000;
}
.copyRight{
    float: right;
    margin-top: 1.3em;
    padding-right: 30px;
}
.ocsLogo{
    width: 50px;
    margin-bottom: 20px;
    display: block;
    position: relative;
}
@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>
<script>
  <meta name="apple-itunes-app" content="app-id=1522698750"></meta>
</script>
<script>
import Menu from "@/components/menu.vue";
import CookieBanner from "@/components/Cookiebanner.vue";
export default {
  components: {
    Menu,
    CookieBanner
  },
  data() {
    return {
      env:[]
    };
  },
  mounted() {
    this.env = process.env
  },
  computed:{
    route(){
      return this.$router.history.current.path
    }
  },
  methods: {
    // Define method that will use the payload to update the data property
    setSeason(payload) {
      this.season = payload.season;
    },
    setCourse(payload) {
      this.course = payload.course;
    },
    setReport(payload) {
      this.currentReport = payload.currentReport;
    },
    setTitle(payload) {
      this.currentTitle = payload.currentTitle;
    },
  },
};
</script>
